import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { showUpdateBottomNavIconDesignSelector } from 'viewModel/selectors/testTarget/showUpdateBottomNavIconDesignSelector';

const { wrapHOC } = FrameworkUtils;

const withInlineBasketProps = wrapHOC(
    connect(
        createStructuredSelector({
            showUpdateBottomNavIconDesign: showUpdateBottomNavIconDesignSelector
        })
    )
);

export { withInlineBasketProps };
